import React, { useState, useEffect } from "react";
import Dashboardlogo from "../../assets/images/logonew.png";
// import Notificationlogo from "../../assets/images/icons/notification.png";
import Profile from "../../assets/images/profile.png";
import Vector from "../../assets/images/Vector.png";
import Admin from "../../assets/images/admin.png";
import Architecture from "../../assets/images/Architecture.png";
import pulseai from "../../assets/images/pulseai.png";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { logout } from '../../services/apiService';

const Header = ({ loading }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [lastname, setLastname] = useState("");
  const [imageurl, setImageurl] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storeLastname = localStorage.getItem("lastname");
    const storeImageUrl = localStorage.getItem("imageurl");
    const token = localStorage.getItem("token");
    const isAdminValue = localStorage.getItem("is_admin");

    if (token) {
      setUsername(storedUsername || "");
      setLastname(storeLastname || "");
      setImageurl(storeImageUrl || "");
      setIsAdmin(parseInt(isAdminValue, 10) === 1); // Parse is_admin to number and check if it's 1
    }
  }, []);

  const handleUserMaster = () => {
    navigate("/user-master"); // Redirect to User Master page
  };

  const handleLogout = async () => {
    try {
      await logout(); // Assuming logout is an async function
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <header>
      <div className="container-fluid">
        <div className="row">
          <nav className="navbar navbar-expand-sm navbar-dark bg-dark top-header-bar">
            <div className="container-fluid">
              {/* <a className="navbar-brand main-dash-logo" href="/home">
                <img src={Dashboardlogo} alt="Clora AI Dashboard Logo" />
              </a> */}
              <Link className="navbar-brand main-dash-logo" to="/home">
                <img src={Dashboardlogo} alt="Home Icon" />
              </Link>
              <div className="">
                <ul className="navbar-nav me-auto"></ul>
                <div className="right-side-code">
                  {/* <div className="right-co">
                    <ul>
                      <li>
                        <a href="/">
                          <img src={Notificationlogo} alt="Notification" />
                        </a>
                      </li>
                    </ul>
                  </div> */}
                  <div className="pro-img dropdown">
                    {/* <span
                      className="dropdown-toggle"
                      role="button"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    > */}
                      {imageurl ? (
                        <img src={imageurl} alt="Profile" />
                      ) : (
                        <img src={Profile} alt="Default Profile" />
                      )}
                      <span className="user-name">
                        {username} {lastname}
                      </span>
                    {/* </span> */}
                    {/* <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                      style={{ cursor: "pointer" }}
                    > */}
                      {/* <li>
                        <span className="dropdown-item text-color">Profile</span>
                      </li>
                      <li>
                        <span className="dropdown-item text-color">Settings</span>
                      </li> */}
                      {/* <hr className="dropdown-divider" /> */}
                      {/* <li>
                        <span
                          className="dropdown-item text-color"
                          onClick={handleLogout}
                          disabled={loading}
                        >
                          {loading ? "Logging out..." : "Logout"}
                        </span>
                      </li>
                    </ul> */}
                  </div>
                </div>
              </div>
            </div>
          </nav>

          <nav className="navbar navbar-expand-sm navbar-dark bg-dark dashboard-menu">
            <div className="container">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#mynavbar"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="mynavbar">
                <ul className="navbar-nav me-auto">
                  <li className="nav-item">
                    <Link className="nav-link" to="/home">
                      <img src={Vector} alt="Home Icon" /> <span>Home</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/data-source">
                      <img src={Architecture} alt="Data Source Icon" /> <span>Data Source</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/pulse-ai">
                      <img src={pulseai} alt="Pulse AI Icon" /> <span>Pulse AI</span>
                    </Link>
                  </li>
                  {isAdmin && (
                    <>
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          href="/"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img src={Admin} alt="Admin Icon" /> <span>Admin</span>{" "}
                          <i className="fa fa-angle-down"></i>
                        </a>
                        <ul className="dropdown-menu" style={{ cursor: "pointer" }}>
                          <li>
                            <span
                              className="dropdown-item"
                              onClick={handleUserMaster}
                            >
                              User Master
                            </span>
                          </li>
                        </ul>
                      </li>
                    </>
                  )}
                  <li className="nav-item">
                    <Link className="nav-link" to="/data-source">
                      <span onClick={handleLogout}>LogOut</span> 
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
